import React, { FC } from 'react';
import classnames from 'classnames/bind';
import styles from './styles.module.css';
import { Radio, TextInputProps } from '..';

const cx = classnames.bind(styles);

export type RadioGroupProps = {
  disabled?: boolean;
  className?: string;
  name: string;
  value: string;
  options: { [value: string]: string };
  stylesVariant?: 'list' | 'inline';
  onChange(value: string): void;
} & Omit<
  TextInputProps,
  'onChange' | 'onClick' | 'onFocus' | 'defaultValue' | 'value'
>;

export const RadioGroup: FC<RadioGroupProps> = ({
  name,
  disabled,
  value,
  options,
  onChange,
  stylesVariant = 'list',
  className,
}) => {
  return (
    <div className={cx('wrapper', stylesVariant, { disabled }, className)}>
      {Object.keys(options).map((option) => (
        <Radio
          disabled={disabled}
          key={option}
          name={name}
          value={options[option]}
          label={options[option]}
          checked={value === option}
          onChecked={() => onChange(option)}
        />
      ))}
    </div>
  );
};
